<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_ca1"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('roadBillReport_search_button')"
          @click="funcFilter()"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('roadBillReport_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
        <el-button
          v-if="
            getLimit('roadBillReport_batchReport_button') && !isAutomaticReport
          "
          @click="getSelectEvent()"
        >
          批量上报
        </el-button>
        <el-button
          v-if="
            getLimit('roadBillReport_batchReportLoadLocation_button') &&
              (loginkTarget == 2 || loginkTarget == 19 || loginkTarget == 22)
          "
          @click="reportOrderDetailLocation(0)"
        >
          批量装货位置上报
        </el-button>
        <el-button
          v-if="
            getLimit('roadBillReport_batchReportUnloadLocation_button') &&
              (loginkTarget == 2 || loginkTarget == 19 || loginkTarget == 22)
          "
          @click="reportOrderDetailLocation(1)"
        >
          批量卸货位置上报
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      highlight-hover-row
      highlight-current-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      show-footer
      :footer-method="footerMethod"
      :checkbox-config="{ highlight: true }"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column type="seq" title="序号" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="260"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="invoiceStatus"
          title="是否开票"
          :formatter="formatterInvoiceStatus"
          min-width="140"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.invoiceStatus"
            clearable
            placeholder="请选择"
          >
            <el-option label="未开票" value="0" />
            <el-option label="已开票" value="1" />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <!--        <vxe-table-column field="whetherOverload" title="是否分单" :formatter="({ cellValue }) => formatterOptions({ cellValue }, 'whetherOverload') "-->
        <!--          min-width="130" />-->
        <vxe-table-column
          field="isSplitOrder"
          title="是否分单"
          :formatter="formatterOverload"
          min-width="140"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isSplitOrder"
            clearable
            placeholder="请选择"
          >
            <el-option label="否" value="0" />
            <el-option label="是" value="1" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="reportProvince == 8">
        <vxe-table-column
          field="isSendCountryStatus"
          title="上报阶段"
          :formatter="
            ({ cellValue }) => formatterOptions({ cellValue }, 'steps')
          "
          min-width="260"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isSendCountryStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in stepsOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="sendTime"
          title="上报时间"
          min-width="360"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.sendTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'sendTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <!-- <el-input
            v-model="listQuery.orderCode"
            placeholder="请输入内容"
            clearable
          /> -->
          <el-input
            v-model="listQuery.orderCode"
            placeholder="点击批量输入运单号"
            clearable
            style="cursor: pointer;"
            @focus="batchInputDialogVisible = true"
          ></el-input>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shippingNoteNumber"
          title="托运单号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shippingNoteNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="errMsg"
          title="上传结果"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.errMsg"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isSend"
          title="上报状态"
          :formatter="
            ({ cellValue }) => formatterOptions({ cellValue }, 'isSend')
          "
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.isSend" clearable placeholder="请选择">
            <el-option
              v-for="item in isSendOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="ordCreatedByName"
          title="托运人名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.ordCreatedByName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentStaffTypeStr"
          title="托运人类型"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.shipmentStaffType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in shipmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="ordCreatedByPhone"
          title="托运人手机号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.ordCreatedByPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人名称"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicense"
          title="车牌号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicense"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="联系方式"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalTypeName"
          title="货物名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalTypeName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="dfName"
          title="下单客户"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.dfName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfShipment"
          title="装货地"
          show-header-overflow
          show-overflow
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfShipment"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfReceipt"
          title="卸货地"
          show-header-overflow
          show-overflow
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfReceipt"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="unloadQuantity"
          title="卸货重量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.unloadQuantityStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.unloadQuantityEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="coalPrice"
          title="货物单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.coalPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.coalPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="price"
          title="成交单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.priceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.priceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="deliveryFeeDeserved"
          title="运费"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryFeeDeservedStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryFeeDeservedEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="distance"
          title="公里数"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.distanceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.distanceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="shipmentDeliveryFeePractical"
          title="托运人实际运费"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentDeliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentDeliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="deliveryFeePractical"
          title="实付运费"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="deliveryCashFee"
          title="实际承运人实收运费"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryCashFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryCashFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="状态"
          :formatter="
            ({ cellValue }) => formatterOptions({ cellValue }, 'status')
          "
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="loginkTarget == 2">
        <vxe-table-column
          field="isSendDishonestyVehicle"
          title="失信车辆上报"
          :formatter="
            ({ cellValue }) => formatterOptions({ cellValue }, 'report')
          "
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isSendDishonestyVehicle"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in reportOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column v-if="loginkTarget == 2">
        <vxe-table-column
          field="isSendLoadLocation"
          title="装货位置上报"
          :formatter="
            ({ cellValue }) => formatterOptions({ cellValue }, 'report')
          "
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isSendLoadLocation"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in reportOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column v-if="loginkTarget == 2">
        <vxe-table-column
          field="sendLoadLocationMsg"
          title="装货位置上报结果"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.sendLoadLocationMsg"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column v-if="loginkTarget == 2">
        <vxe-table-column
          field="isSendUnloadLocation"
          title="卸货位置上报"
          :formatter="
            ({ cellValue }) => formatterOptions({ cellValue }, 'report')
          "
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isSendUnloadLocation"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in reportOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column v-if="loginkTarget == 2">
        <vxe-table-column
          field="sendUnloadLocationMsg"
          title="卸货位置上报结果"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.sendUnloadLocationMsg"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="接单时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="fillTime"
          title="装货时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.fillTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'fillTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastLoadingTime"
          title="截止装货时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastLoadingTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastLoadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="signTime"
          title="卸货时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.signTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'signTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastUnloadingTime"
          title="截止卸货时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastUnloadingTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastUnloadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtModified"
          title="最后操作时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtModifiedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtModified')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="modifiedByName"
          title="最后操作人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.modifiedByName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="200" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('roadBillReport_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
            width="50"
          >
            <vxe-button type="text" @click="orderDesil(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('roadBillReport_report_button') &&
                scope.row.isSend != 1 &&
                !(isAutomaticReport && scope.row.isSend != 2)
            "
            class="item"
            effect="dark"
            content="上报"
            placement="top"
            width="50"
          >
            <vxe-button type="text" @click="orderopen(scope.row)">
              <i class="el-icon-top-right" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('roadBillReport_split_button') &&
                scope.row.isSplitOrder != 0
            "
            class="item"
            effect="dark"
            content="分单"
            placement="top"
            width="50"
          >
            <vxe-button type="text" @click="splitOrder(scope.row.code)">
              <i class="el-icon-tickets" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('roadBillReport_reportLoadLocation_button') &&
                (loginkTarget == 2 || loginkTarget == 19) &&
                scope.row.isSendLoadLocation != 1
            "
            class="item"
            effect="dark"
            content="装货位置上报"
            placement="top"
            width="50"
          >
            <vxe-button
              type="text"
              @click="reportOrderDetailLocation(0, scope.row.code)"
            >
              <i class="el-icon-upload2" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('roadBillReport_reportUnloadLocation_button') &&
                (loginkTarget == 2 || loginkTarget == 19) &&
                scope.row.isSendUnloadLocation != 1
            "
            class="item"
            effect="dark"
            content="卸货位置上报"
            placement="top"
            width="50"
          >
            <vxe-button
              type="text"
              @click="reportOrderDetailLocation(1, scope.row.code)"
            >
              <i class="el-icon-top" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('roadBillReport_reportDishonestyVehicle_button') &&
                loginkTarget == 2 &&
                scope.row.isSendDishonestyVehicle != 1
            "
            class="item"
            effect="dark"
            content="失信车辆上报"
            placement="top"
            width="50"
          >
            <vxe-button
              type="text"
              @click="reportDishonestyVehicle(scope.row.code)"
            >
              <i class="el-icon-thumb" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="loginkTarget == 3 && scope.row.isInsure === 0"
            class="item"
            effect="dark"
            content="线下保险信息"
            placement="top"
            width="50"
          >
            <!-- v-if=" loginkTarget == 3 && scope.row.isInsure === 0" -->
            <vxe-button type="text" @click="offlineInsurance(scope.row.code)">
              <i class="el-icon-receiving" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('roadBillReport_recordList_button')"
            class="item"
            effect="dark"
            content="上报记录"
            placement="top"
            width="50"
          >
            <vxe-button
              type="text"
              @click="reportRecordList(scope.row.shippingNoteNumber)"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <!--          <el-tooltip-->
          <!--            class="item"-->
          <!--            effect="dark"-->
          <!--            content="报文详情"-->
          <!--            placement="top"-->
          <!--            width="50"-->
          <!--            v-if="scope.row.isSend === 1"-->
          <!--          >-->
          <!--            <vxe-button type="text" @click="orderDatagram(scope.row.code)">-->
          <!--              <i class="el-icon-document" />-->
          <!--            </vxe-button>-->
          <!--          </el-tooltip>-->
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="tuteship"
      title="运输单详情"
      width="1000"
      height="80%"
      resize
    >
      <ordergoods ref="detailRef" @openMap="openMap" />
    </vxe-modal>
    <vxe-modal
      v-model="splitOrderFlag"
      title="子单详情"
      width="1000"
      height="80%"
      resize
    >
      <splitOrder ref="splitOrderRef" />
    </vxe-modal>
    <vxe-modal
      v-model="offlineFlag"
      title="线下保险信息"
      width="800"
      height="85%"
      resize
      @onHideModeloffline="fatherCancelReoffline"
    >
      <offlineInsuranceDetail ref="orderOfflineRef" />
    </vxe-modal>
    <vxe-modal
      v-model="datagramFlag"
      title="报文详情"
      width="800"
      height="85%"
      resize
    >
      <orderDatagramDetail ref="orderDatagramRef" />
    </vxe-modal>
    <vxe-modal
      v-model="positionFlag"
      title="运单轨迹"
      width="88%"
      height="96%"
      resize
      remember
    >
      <Position :key="timer" ref="positionRef" type="inTransit" />
    </vxe-modal>
    <vxe-modal
      v-model="reportFlag"
      title="运单上报"
      width="88%"
      height="96%"
      resize
      remember
    >
      <reportConfirm
        :key="timer"
        ref="confirmRef"
        type="reportConfirm"
        @onHideReport="hideReport"
      />
    </vxe-modal>
    <vxe-modal
      v-model="dishonestyReasonFlag"
      title="添加备注"
      width="500"
      height="auto"
      :lock-scroll="false"
    >
      <dishonestyReason
        ref="dishonestyReasonRef"
        @onHideModel="fatherCancel"
        @onHideModelAndrefresh="fatherCancelRefresh"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
    <vxe-modal
      v-model="recordFlag"
      title="上报记录"
      width="88%"
      height="96%"
      resize
      remember
    >
      <reportRecordList
        :key="timer"
        ref="recordRef"
        @onHideModel="hideRecord"
      />
    </vxe-modal>
    <el-dialog
      title="批量输入运单号"
      :visible.sync="batchInputDialogVisible"
      width="650px"
      height="900px"
      class="batch-input-dialog"
    >
      <BatchWaybill
        :codes="listQuery.orderCode"
        @confirmBatchInput="confirmBatchInput"
      ></BatchWaybill>
    </el-dialog>
  </div>
</template>
<script>
import BatchWaybill from "@/components/BatchWaybill";
import {
  orderDetailList,
  reportOrderDetailLocation,
  verifyAPPLocationStatus,
  reportHubeiTransportWaybill,
  hubeiList
} from "@/api/transport";
import ordergoods from "@/components/WaybillDetails";
import splitOrder from "@/views/tms/order/splitOrder";
import orderDatagramDetail from "./components/orderDatagramDetail.vue";
import offlineInsuranceDetail from "./components/offlineInsuranceDetail.vue";
import dishonestyReason from "./components/dishonestyReason.vue";
import Position from "./components/position.vue";
import reportConfirm from "./components/reportConfirm.vue";
import reportRecordList from "./components/reportRecordList.vue";
import { mapState } from "vuex";
export default {
  components: {
    ordergoods,
    orderDatagramDetail,
    offlineInsuranceDetail,
    dishonestyReason,
    splitOrder,
    Position,
    reportConfirm,
    reportRecordList,
    BatchWaybill
  },
  data() {
    return {
      batchInputDialogVisible: false,
      exportObj: {
        exportUrl: "/ntocc-tms-api/orderDetail/exportRoadBillReport", //导出接口
        name: "路单上报"
      },
      tuteship: false,
      offlineFlag: false,
      datagramFlag: false,
      splitOrderFlag: false,
      positionFlag: false,
      dishonestyReasonFlag: false,
      reportFlag: false,
      recordFlag: false,
      timer: "",
      message: "",
      coderderTrack: "",
      loading: false,
      tableData: [],
      reportProvince: "",
      listQuery: {
        gmtCreatedRange: "",
        fillTimeRange: "",
        lastLoadingTimeRange: "",
        signTimeRange: "",
        lastUnloadingTimeRange: "",
        gmtModifiedRange: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        reportMark: 0,
        greaterStatus: 3, // status 大于3的，已核算和已打款的
        errMsg: "",
        isReportPage: 1, // 上报页面查询需传1
        notEqualIsTransfer: 2 // 状态2，不能上报
      },
      sumObject: {},
      loginkTarget: 0,
      flag: false,
      formatterInvoiceStatus({ cellValue }) {
        switch (cellValue) {
          case 1:
            return "已开票";
          case 0:
            return "未开票";
        }
      },
      formatterOverload({ cellValue }) {
        switch (cellValue) {
          case 1:
            return "是";
          case 0:
            return "否";
          default:
            return "否";
        }
      },
      stepsOptions: [
        { label: "未开始", value: 0 },
        { label: "第一阶段", value: 1 },
        { label: "第二阶段", value: 2 },
        { label: "完成", value: 3 }
      ],
      shipmentOptions: [
        { label: "个体托运人", value: 0 },
        { label: "企业托运人", value: 1 }
      ],
      // 超载
      whetherOverloadOptions: [
        { label: "未超载", value: 0 },
        { label: "超载", value: 1 }
      ],
      // 结算
      statusOptions: [
        { value: 4, label: "已结算" },
        { value: 5, label: "已打款" }
      ],
      reportOptions: [
        { value: 0, label: "未上报" },
        { value: 1, label: "已上报" },
        { value: 2, label: "上报失败" }
      ],
      // 上报
      isSendOptions: [
        { value: 0, label: "未上报" },
        { value: 1, label: "已上报" },
        { value: 2, label: "上报失败" }
      ],
      toolbarButtons: [
        {
          code: "btn1",
          name: "查询"
        },
        {
          name: "下拉按钮",
          dropdowns: [
            {
              name: "按钮111",
              code: "btn2"
            },
            {
              name: "按钮222",
              code: "btn3"
            }
          ]
        }
      ],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  computed: {
    ...mapState({
      isAutomaticReport: state => state.user.party.isAutomaticReport
    })
  },
  created() {
    let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    this.reportProvince =
      dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince.configValue;
    this.loginkTarget = dataBranch.partyGroupConfigCacheMap
      .loginkTarget_reportProvince
      ? dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince
          .configValue
      : 0;
    this.findList();
  },
  methods: {
    confirmBatchInput(parsedOrderCodes) {
      if (parsedOrderCodes.length > 300) {
        this.$message.warning("运单号数量不能超过300个");
        return;
      }
      this.listQuery.orderCode = parsedOrderCodes.join(",");
      this.batchInputDialogVisible = false;
      this.funcFilter();
    },
    openMap() {
      this.positionFlag = true;
      this.$refs.positionRef.getMarkPath(this.coderderTrack);
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        hubeiList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    hideReport() {
      this.reportFlag = false;
      this.findList();
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    orderDesil(c) {
      //console.log(c)
      this.$refs.detailRef.Getdetails(c);
      this.tuteship = true;
      this.coderderTrack = c;
      this.timer = new Date().getTime();
    },
    //分单
    splitOrder(row) {
      this.$refs.splitOrderRef.findList(row);
      this.splitOrderFlag = true;
    },
    orderDatagram(c) {
      this.$refs.orderDatagramRef.getDatagram(c);
      this.datagramFlag = true;
    },
    offlineInsurance(c) {
      this.$refs.orderOfflineRef.getDatagram(c);
      this.offlineFlag = true;
    },
    orderopen(c) {
      let rLoading = this.openLoading();
      verifyAPPLocationStatus({ codes: c.code }).then(response => {
        rLoading.close();
        if (response.data.length > 0) {
          this.$confirm("该运单省平台SDK位置未上报，是否继续上报?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              this.repotySumbit(c.code);
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消"
              });
            });
        } else {
          this.repotySumbit(c.code);
        }
      });
    },
    repotySumbit(code) {
      this.$confirm("请确认是否要发送数据到网络货运监测平台？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const rLoading = this.openLoading();
        const codes = code;
        reportHubeiTransportWaybill({ codes })
          .then(response => {
            this.$message({
              type: "success",
              message: response.msg
            });
          })
          .finally(() => {
            this.$refs.xTable.clearCheckboxRow();
            this.findList();
            rLoading.close();
          });
      });
    },
    reportDishonestyVehicle(c) {
      this.dishonestyReasonFlag = true;
      this.$refs.dishonestyReasonRef.getInfo(c);
    },
    fatherCancel() {
      this.dishonestyReasonFlag = false;
    },
    fatherCancelRefresh() {
      this.dishonestyReasonFlag = false;
      this.findList();
    },
    fatherCancelReoffline() {
      this.offlineFlag = false;
      this.findList();
    },
    getSelectEvent() {
      const selectRecords = this.$refs.xTable.getSelectRecords();

      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择运单", type: "warning" });
      } else if (selectRecords.length > 100) {
        this.$message({ message: "最多批量上报100条数据", type: "warning" });
        return false;
      } else {
        var branchCode = "";
        var flag = true;
        for (var i = 0; i < selectRecords.length; i++) {
          branchCode = selectRecords[0].branchCode;
          if (branchCode !== selectRecords[i].branchCode) {
            flag = false;
          }
        }
        if (!flag) {
          this.$message({ message: "请选择同一机构的信息！", type: "error" });
        } else {
          const codes = selectRecords.map(item => item.code).join(",");
          let rLoading = this.openLoading();
          verifyAPPLocationStatus({ codes }).then(response => {
            rLoading.close();
            if (response.data.length > 0) {
              this.reportFlag = true;
              this.$nextTick(function() {
                this.$refs.confirmRef.verifyAPPLocation(codes);
              });
            } else {
              this.$confirm("确认上报监管平台吗？").then(_ => {
                let rLoading = this.openLoading();
                reportHubeiTransportWaybill({ codes })
                  .then(response => {
                    rLoading.close();
                    this.$message({ message: response.msg, type: "success" });
                  })
                  .finally(() => {
                    this.$refs.xTable.clearCheckboxRow();
                    this.findList();
                    rLoading.close();
                  });
              });
            }
          });
        }
      }
    },
    reportOrderDetailLocation(locationType, code) {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (!code && (!selectRecords || selectRecords.length === 0)) {
        this.$message({
          message: "请选择需要进行位置上报的运单",
          type: "warning"
        });
      } else {
        // 先进行过滤  去除已经上报完成的codes  isSendLoadLocation
        let filterLoadLocationRecords = selectRecords.filter(
          item => item.isSendLoadLocation != 1
        );
        let filterUnloadLocationRecords = selectRecords.filter(
          item => item.isSendUnloadLocation != 1
        );
        let loadcodes = filterLoadLocationRecords
          .map(item => item.code)
          .join(",")
          ? filterLoadLocationRecords.map(item => item.code).join(",")
          : code;
        let unloadcodes = filterUnloadLocationRecords
          .map(item => item.code)
          .join(",")
          ? filterUnloadLocationRecords.map(item => item.code).join(",")
          : code;
        this.$confirm("确认进行位置上报吗？").then(_ => {
          const rLoading = this.openLoading();
          let codes = "";
          codes = locationType == 0 ? loadcodes : unloadcodes;
          reportOrderDetailLocation({
            codes: codes,
            locationType: locationType
          })
            .then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
            })
            .catch(() => {
              rLoading.close();
            })
            .finally(() => {
              this.$refs.xTable.clearCheckboxRow();
              this.findList();
              rLoading.close();
            });
        });
      }
    },
    reportRecordList(shippingNoteNumber) {
      this.recordFlag = true;
      this.$refs.recordRef.init(shippingNoteNumber);
    },
    hideRecord() {
      this.recordFlag = false;
    },
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    // 翻译
    formatterOptions({ cellValue }, prefix) {
      const item = this[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          // if (column.property === "shipperDeliveryFee") {
          //   return this.sumObject.shipperDeliveryFee;
          // }
          // if (column.property === "deliveryFeePractical") {
          //   return this.sumObject.deliveryFeePractical;
          // }
          // if (column.property === "deliveryCashFee") {
          //   return this.sumObject.deliveryCashFee;
          // }
          // if (column.property === "taxFee") {
          //   return this.sumObject.taxFee;
          // }
          // if (column.property === "taxPayFee") {
          //   return this.sumObject.taxPayFee;
          // }
          // if (column.property === "distance") {
          //   return this.sumObject.distance;
          // }
          // if (column.property === "deliveryOilFee") {
          //   return this.sumObject.deliveryOilFee;
          // }
          // if (column.property === "deliveryFeeDeserved") {
          //   return this.sumObject.deliveryFeeDeserved;
          // }
          // if (column.property === "weight") {
          //   return (
          //     this.sumObject.ton +
          //     "吨//" +
          //     this.sumObject.cubicMeter +
          //     "方//" +
          //     this.sumObject.pieces +
          //     "件"
          //   );
          // }
          // if (column.property === "loadQuantity") {
          //   return (
          //     this.sumObject.loadQuantityTon +
          //     "吨//" +
          //     this.sumObject.loadQuantityCubicMeter +
          //     "方//" +
          //     this.sumObject.loadQuantityPieces +
          //     "件"
          //   );
          // }
          // if (column.property === "unloadQuantity") {
          //   return (
          //     this.sumObject.unloadQuantityTon +
          //     "吨//" +
          //     this.sumObject.unloadQuantityCubicMeter +
          //     "方//" +
          //     this.sumObject.unloadQuantityPieces +
          //     "件"
          //   );
          // }
          if (
            [
              "unloadQuantity",
              "deliveryFeeDeserved",
              "shipperDeliveryFee",
              "deliveryFeePractical",
              "deliveryCashFee",
              "shipmentDeliveryFeePractical"
            ].includes(column.property)
          ) {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    }
  }
};
</script>

<style></style>
